import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { newFeatures2025 } from '../../data/features';
import styles from './WhatsNewSection.module.css';

const FeatureCard = ({ feature, index, inView }) => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const images = feature.images || [];
  const hasMultipleImages = images.length > 1;

  const nextImage = () => {
    setCurrentImageIndex((prev) => (prev + 1) % images.length);
  };

  const prevImage = () => {
    setCurrentImageIndex((prev) => (prev - 1 + images.length) % images.length);
  };

  return (
    <motion.div
      className={styles.featureCard}
      initial={{ opacity: 0, x: -30 }}
      animate={inView ? { opacity: 1, x: 0 } : { opacity: 0, x: -30 }}
      transition={{ duration: 0.5, delay: index * 0.1 }}
    >
      {images.length > 0 && (
        <div className={styles.featureImageContainer}>
          <img 
            src={images[currentImageIndex]} 
            alt={`${feature.title} - Image ${currentImageIndex + 1}`}
            className={styles.featureImage}
          />
          {hasMultipleImages && (
            <>
              <button 
                className={`${styles.imageNav} ${styles.imageNavPrev}`}
                onClick={prevImage}
                aria-label="Previous image"
              >
                ‹
              </button>
              <button 
                className={`${styles.imageNav} ${styles.imageNavNext}`}
                onClick={nextImage}
                aria-label="Next image"
              >
                ›
              </button>
              <div className={styles.imageIndicators}>
                {images.map((_, idx) => (
                  <button
                    key={idx}
                    className={`${styles.indicator} ${idx === currentImageIndex ? styles.indicatorActive : ''}`}
                    onClick={() => setCurrentImageIndex(idx)}
                    aria-label={`Go to image ${idx + 1}`}
                  />
                ))}
              </div>
            </>
          )}
        </div>
      )}
      <div className={styles.featureContent}>
        <h3 className={styles.featureTitle}>{feature.title}</h3>
        <p className={styles.featureDescription}>{feature.description}</p>
      </div>
    </motion.div>
  );
};

const WhatsNewSection = () => {
  const { ref, inView } = useInView({
    threshold: 0.1,
    triggerOnce: true
  });

  return (
    <section className={styles.whatsNew} aria-labelledby="new-features-title">
      <div className={styles.container}>
        <div className={styles.header}>
          <h2 id="new-features-title" className={styles.title}>
            What's New in 2025
          </h2>
          <p className={styles.description}>
            Five exciting new features enhancing the student experience
          </p>
        </div>

        <motion.div
          ref={ref}
          className={styles.features}
          initial={{ opacity: 0 }}
          animate={inView ? { opacity: 1 } : { opacity: 0 }}
        >
          {newFeatures2025.map((feature, index) => (
            <FeatureCard 
              key={feature.id}
              feature={feature}
              index={index}
              inView={inView}
            />
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default WhatsNewSection;
